<template>
	<div>
		<!-- header开始 -->
		<div class="header">
			 <div class="header-logo">
				<img src="../assets/images/s_logo.png" alt="">
			 </div>
			 <ul class="header-nav">
				<li v-for="(item,index) in headerNav" :key="index">
					<a :href="item.href" target="_blank">{{item.val}}</a>
				</li>
			 </ul>
		</div>
        <el-divider></el-divider>
	</div>
</template>

<script>
 
import { mapState, mapMutations, mapActions } from "vuex";
 
export default {
	data() {
		return { 
			activeVar:0, 
			userName: "",
			pedding: "",  
			headerNav:[
				{
					val:'首页',
					type:'1',
					href:'https://ai.tcmcds.com/tcmkb/pages/home_index.jsp',
				},{
					val:'资源中心',
					type:'2',
					href:'https://ai.tcmcds.com/tcmkb/pages/ziyuanzhongxin.jsp'
				},{
					val:'应用中心',
					type:'3',
					href:'https://ai.tcmcds.com/tcmkb/pages/yingyongzhongxin.jsp'
				},{
					val:'院士专家',
					type:'4',
					href:'https://ai.tcmcds.com/tcmkb/pages/yuanshizhuanti.jsp'
				}
			]
		};
	},
	computed: {
		...mapState([''])	
	},
	mounted() {
		 
		 
	},
	methods: {
		 
	},
};
</script>

<style lang="less" scoped>
.header{
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 1200px;
	margin: 0 auto;
	padding:10px 0;
	.header-nav{
		display: flex;
		li{
			margin: 0 10px;
			a{
				color: #000;
				text-decoration: none;
			}
		}
	}
}
</style>
